import { useRef, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { useOutsideClick } from '../../CustomHooks';
import { ExternalLink } from '../ExternalLink';
import { Icon } from '@iconify/react';
import bxChevronDown from '@iconify-icons/bx/bx-chevron-down';
import styles from './UnauthenticatedHeader.module.scss';

interface SubItem {
  name: string;
  route: string;
}

interface NavProps {
  history: RouteComponentProps['history'];
  name: string;
  description: string;
  icon: string;
  route: string;
  hasSubMenu: boolean;
  onClickCallback?: () => void;
  isMobile?: boolean;
  subItems?: SubItem[];
  refEl?: React.RefObject<HTMLLIElement>;
  onHover?: () => void;
  onLeave?: () => void;
}

const HeaderNavItem = ({
  name,
  route,
  history,
  hasSubMenu,
  subItems,
  onClickCallback,
  isMobile,
  refEl,
  onHover,
  onLeave,
}: NavProps): JSX.Element => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const ref = useRef<HTMLUListElement>(null);
  useOutsideClick(ref, () => setShowSubMenu(false));

  const handleClick = () => {
    if (route?.includes('http')) {
      window.open(route, '_blank');
    } else {
      history.push(route);
    }
    if (onClickCallback) onClickCallback();
  };

  const handleMouseEnter = () => {
    if (!isMobile && onHover) {
      onHover();
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setShowSubMenu(false);
      if (onLeave) {
        onLeave();
      }
    }
  };

  if (!hasSubMenu) {
    return (
      <ul className={styles.headerButton}>
        <li>
          <Link onClick={handleClick} to={route}>
            <span>{name}</span>
          </Link>
        </li>
      </ul>
    );
  }

  return (
    <ul
      ref={isMobile ? ref : null}
      className={styles.menuContainer}
      onClick={() => setShowSubMenu(!showSubMenu)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <li className={styles.headerButton} ref={refEl}>
        <button className={styles.resembleLinkButton}>
          <span>{name}</span>
          <Icon
            className={styles.chevron}
            icon={bxChevronDown}
            width={18}
            height={18}
            color={isMobile ? 'white' : '#00afd8'}
          />
        </button>
      </li>
      {showSubMenu && isMobile && (
        <ul className={styles.dropdownBox}>
          {subItems &&
            subItems.map((sm, index) => (
              <li key={`submenu-${index}`} className={styles.dropdownItem}>
                {sm.route.includes('http') ? (
                  <ExternalLink href={sm.route}>
                    <span>{sm.name}</span>
                  </ExternalLink>
                ) : sm.route === 'contact' ? (
                  <a href='mailto:hello@peekapak.com' target='_blank' rel='noreferrer noopener'>
                    {sm.name}
                  </a>
                ) : (
                  <Link to={sm.route} onClick={handleClick}>
                    <span>{sm.name}</span>
                  </Link>
                )}
              </li>
            ))}
        </ul>
      )}
    </ul>
  );
};

export default HeaderNavItem;
